import type { MouseEvent } from "react";

/**
 * True for an unmodified primary-button click. Modified clicks (Cmd/Ctrl/Shift/Alt)
 * and middle clicks must fall through to the browser so open-in-new-tab,
 * download, and copy-link-address keep working.
 */
export const isPlainLeftClick = (event: MouseEvent<Element>): boolean =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
